import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap';
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";

import './assets/css/adminlte.css'
import './assets/css/fontawesome-all.css'
// Views
import Login from './views/LoginV2'
import AdminLayout from "./layout/admin"
import Changepass from './views/Changepass'

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/login" render={props => <Login {...props} />}></Route>
        <Route path="/changepass" render={props => <Changepass {...props} />}></Route>
        <Route path="/admin" render={props => <AdminLayout {...props} />} />

        {/* <Redirect from="/" to="/login" /> */}
        <Redirect from="/" to="/login" />
      </Switch>
    </Router>
  );
}

export default App;
